<div>
	<div class="summary-and-filter-container">
		<div>
			<div class="title">{{ client()?.active_text?.name }}</div>
			<app-journey-school-report-summary [report]="report()"></app-journey-school-report-summary>
		</div>
	</div>

	<app-reporting-table [loading]="loading()" [rows]="rows()" [columns]="columns()">
		<!-- Header templates (defines order/keys) -->
		<ng-template appHeaderColumn="sectionName">Class</ng-template>
		<ng-template appHeaderColumn="teacher">Teacher</ng-template>
		<ng-template appHeaderColumn="activities">Activities Completed</ng-template>

		<!-- Cell templates (matched by key; use {{ row.name }} etc.) -->
		<ng-template appRowColumn="sectionName" let-row>
			<div class="name-column" (click)="onRowClick(row)">{{ row.sectionName }}</div>
		</ng-template>
		<ng-template appRowColumn="teacher" let-row>
			{{
				row.teacherUuids && row.teacherUuids.length > 0
					? (row.teacherUuids[0] | displayName: 'user' | async)
					: 'Not assigned yet'
			}}

			@if (row.teacherUuids && row.teacherUuids.length > 1) {
				<span class="extra-teachers">+{{ row.teacherUuids.length - 1 }}</span>
			}
		</ng-template>
		<ng-template appRowColumn="activities" let-row>{{ row.activityCount | number }}</ng-template>
	</app-reporting-table>
</div>
